import {Component, OnInit, ViewChild} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {SystemUser} from '../../../../shared/Models/SystemUser';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LanguageService} from '../../../../translation/Services/language.service';
import {Helper} from '../../../../helpers/helper.service';
import {TranslateService} from '@ngx-translate/core';
import {UsersService} from '../../../Services/users.service';
import {environment} from '../../../../../environments/environment';
import { BackofficeRole } from '../../../../back-office/Models/BackofficeRole';

@Component({
  selector: 'app-manage-system-users',
  templateUrl: './manage-system-users.component.html',
  styleUrls: ['./manage-system-users.component.scss']
})
export class ManageSystemUsersComponent implements OnInit {
  public classicBox;
  public lastValue = <any>{};
  public enableSave = true;
  form = new UntypedFormGroup({});
  model: any = {};
  public systemUser: SystemUser = new SystemUser();
  public systemUserId: number;
  public isEdit = false;
  public languages = [];
  public backofficeRoles = [];
  public showAuth = false;
  options: FormlyFormOptions = {};
  @ViewChild('classicForm', { static: false }) child;


  constructor(
    private route: ActivatedRoute,
    public languageService: LanguageService,
    public helper: Helper,
    private translate: TranslateService,
    private router: Router,
    private userService: UsersService
  ) {
  }


  ngOnInit() {
    this.route.params.subscribe(params => {
      new Promise((resolve, reject) => {
        if (Helper.isDefined(params['id'])) {
          this.systemUserId = params['id'];
          this.isEdit = true;
          this.userService.getUser(this.systemUserId).subscribe((user) => {
            resolve(user);
          });
        } else {
          resolve(new SystemUser());
        }
      }).then((user) => {
        if (this.isEdit) {
          this.lastValue = {user: user, auth: user};
          this.lastValue.user.language = this.lastValue.user.language.id;
          this.lastValue.user.role = this.lastValue.user.role.id;
        }
      }).then(() => {
        this.languageService.list().subscribe(response => {
          response.languages.map((value) => {
            if (value && value.name && value.id) {
              this.languages.push({
                label: value.name,
                value: value.id
              });
            }
          });

          this.userService.getBackofficeRoles().subscribe(roles => {
            const roleItem = roles.data;
            if (this.backofficeRoles.length === 0) {
              roleItem.map((value) => {
                this.backofficeRoles.push({
                  label: this.translate.instant(value.name),
                  value: value.id,
                });
              });
            }
            this.classicBox = <FormlyFieldConfig>[
              {
                fieldGroupClassName: 'row',
                key: 'user',
                fieldGroup: [
                  {
                    className: 'col-3 ',
                    type: 'input',
                    key: 'firstName',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.firstName'),
                      required: true,
                      pattern: '[a-zA-Z _-]+',
                      maxLength: environment.maxStringLength,

                    },
                    validation: {
                      messages: {
                        pattern: this.translate.instant('errors.invalid'),
                        required: this.translate.instant('errors.required'),
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                      },

                    },
                  },
                  {
                    className: 'col-3',
                    type: 'input',
                    key: 'lastName',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.lastName'),
                      required: true,
                      pattern: '[a-zA-Z _-]+',
                      maxLength: environment.maxStringLength,
                    },
                    validation: {
                      messages: {
                        pattern: this.translate.instant('errors.invalid'),
                        required: this.translate.instant('errors.required'),
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                      },

                    },
                  },
                ],
              },
              {
                className: 'section-label',
                template: '<div class="m-b-10"><strong>' + this.translate.instant('doctrine.user.address') + '</strong></div><hr />',
              },
              {
                fieldGroupClassName: 'row',
                key: 'user',
                fieldGroup: [
                  {
                    className: 'col-3 ',
                    type: 'input',
                    key: 'email',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.email'),
                      maxLength: environment.maxStringLength,
                      pattern: environment.emailPattern,
                    },
                    validation: {
                      messages: {
                        pattern: this.translate.instant('errors.invalid'),
                        required: this.translate.instant('errors.required'),
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                      },
                    },

                  },
                  {
                    className: 'col-3',
                    type: 'input',
                    key: 'phone',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.phone'),
                      required: true,
                      pattern: '[0-9]+',
                      maxLength: environment.maxStringLength,
                    },
                    validation: {
                      messages: {
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength}),
                        pattern: this.translate.instant('errors.invalid'),
                        required: this.translate.instant('errors.required')
                      },
                    },
                  },
                ],
              },
              {
                className: 'section-label',
                template: '<div class="m-b-10"><strong>' + this.translate.instant('doctrine.user.language') + ' </strong></div><hr />',
              },
              {
                fieldGroupClassName: 'row',
                key: 'user',
                fieldGroup: [
                  {
                    key: 'language',
                    type: 'ng-select',
                    className: 'col-3 ',
                    templateOptions: {
                      label: this.translate.instant('doctrine.attributes.language'),
                      options: this.languages,
                      required: true,
                    },

                  },
                ],
              },
              {
                className: 'section-label',
                template: '<div class="m-b-10 mt-3"><strong>' + this.translate.instant('doctrine.user.login_credential') + ' </strong></div><hr />',
              },
              {
                fieldGroupClassName: 'row',
                key: 'auth',
                fieldGroup: [
                  {
                    className: 'col-3 ',
                    type: 'input',
                    key: 'username',
                    pattern: '[a-zA-Z _-]+',
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.username'),
                      required: true,
                      maxLength: environment.maxStringLength,
                    },
                    validation: {
                      messages: {
                        required: this.translate.instant('errors.required'),
                        pattern: this.translate.instant('errors.invalid'),
                        maxlength: (error, field: FormlyFieldConfig) => this.translate.instant('validators.max_message', {limit: field.templateOptions.maxLength})
                      },
                    },
                  },
                  {
                    className: 'col-3 changePassword-button d-flex align-items-center',
                    type: 'button',
                    hideExpression: (model) => !this.isEdit,
                    templateOptions: {
                      text: this.translate.instant('admin.dealer.account.change_password'),
                      btnType: 'primary',
                      onClick: ($event) => {
                        this.showAuth = !this.showAuth;
                      },
                    },
                  }
                ],
              },
              {
                fieldGroupClassName: 'row',
                key: 'auth',
                validators: {
                  fieldMatch: {
                    expression: (control) => {
                      const value = control.value;
                      if (this.showAuth || !this.isEdit) {
                        return value.plainPasswordConfirm === value.plainPassword || (!value.plainPasswordConfirm && !value.plainPassword);
                      }
                      return true;
                    },
                    message: this.translate.instant('errors.passwordMatch'),
                    errorPath: 'plainPasswordConfirm',
                  },
                },
                fieldGroup: [
                  {
                    className: 'col-3',
                    type: 'input',
                    key: 'plainPassword',
                    hideExpression: (model) => (!this.showAuth) && (this.isEdit),
                    templateOptions: {
                      label: this.translate.instant('doctrine.user.plainPassword'),
                      required: () => ((!this.showAuth) && (this.isEdit)),
                      type: 'password',
                      minLength: environment.minPassword,
                      maxLength: environment.maxStringLength,
                    },
                    validation: {
                      messages: {
                        minLength: this.translate.instant('validators.password.length.min',
                          {limit: environment.minPassword}),
                        maxLength: this.translate.instant('validators.password.length.max',
                          {limit: environment.maxStringLength}),
                        pattern: this.translate.instant('errors.invalid'),
                        required: this.translate.instant('errors.required'),
                        lowerCase: this.translate.instant('validators.password.contain.lowercase'),
                        uppercase: this.translate.instant('validators.password.contain.uppercase'),
                        number: this.translate.instant('validators.password.contain.number'),
                        special: this.translate.instant('validators.password.contain.special'),
                      },
                    },
                    validators:  {
                      validation: ['lowerCase', 'uppercase', 'number', 'special'],
                    },
                  },
                  {
                    className: 'col-3',
                    type: 'input',
                    key: 'plainPasswordConfirm',
                    hideExpression: (model) => (!this.showAuth) && (this.isEdit),
                    templateOptions: {
                      type: 'password',
                      label: this.translate.instant('doctrine.user.plainPasswordConfirm'),
                    }
                  }]
              },
              {
                className: 'section-label',
                template: '<div class="m-b-10"><strong>' + this.translate.instant('doctrine.user.other') + ' </strong></div><hr />',
              },
              {
                fieldGroupClassName: 'row',
                key: 'user',
                fieldGroup: [
                  {
                    key: 'status',
                    type: 'ng-select',
                    className: 'col-3 ',
                    defaultValue: SystemUser.SYSTEMUSER_ACTIVE,
                    templateOptions: {
                      clearable: false,
                      label: this.translate.instant('doctrine.user.status'),
                      options: [
                        {label: this.translate.instant('global.active'), value: SystemUser.SYSTEMUSER_ACTIVE},
                        {label: this.translate.instant('global.inactive'), value: SystemUser.SYSTEMUSER_INACTIVE},
                      ],
                      required: true,
                    },
                  },
                  {
                    key: 'role',
                    type: 'ng-select',
                    className: 'col-3 ',
                    defaultValue: this.backofficeRoles.find(item => item.label === this.translate.instant(BackofficeRole.ROLE_ADMIN)).value,
                    templateOptions: {
                      clearable: false,
                      label: this.translate.instant('doctrine.user.role'),
                      options: this.backofficeRoles,
                      required: true,
                    },
                  },
                ],
              },
            ];
          });
        });
      });
    });
  }

  enableButton(event) {

    this.enableSave = event;
  }

  submitItem(next: boolean) {
    if (next) {
      const login = JSON.parse(JSON.stringify(this.lastValue.user));
      const auth = JSON.parse(JSON.stringify(this.lastValue.auth));
      const user = Object.assign(login, auth);
      delete user.lastRequest;
      delete user.plainPasswordConfirm;
      delete user.roles;
      delete user.user;
      delete user.id;
      delete user.isAllowedPartialPaid;
      delete user.dealerPoints;
      delete user.isGoogleAuthenticatorEnabled;
      delete user.isBillingAccount;
      delete user.isPrivateAccount;
      delete user.isCustomerAccount;
      // delete user.role;
      delete user.companyPhone;
      this.userService.manageUser(user, this.isEdit, this.systemUserId).subscribe((resp) => {
        this.router.navigateByUrl('/back-office/system-user/overview');
      });
    } else {
      this.router.navigateByUrl('/back-office/system-user/overview');
    }

  }
}
